<template>
    <div class="kiaf-personal-log">
        <div class="form">
            <kc-form :inline="true" label-width="3.4rem" class="form-inline">
                <kc-form-item label="开始时间" class="item item-first">
                    <kc-date-picker
                            v-model="statTime"
                            type="datetime"
                            value-format="timestamp"
                            placeholder="开始时间">
                    </kc-date-picker>
                </kc-form-item>
                <kc-form-item label="结束时间" class="item">
                    <kc-date-picker
                            v-model="endTime"
                            type="datetime"
                            value-format="timestamp"
                            placeholder="结束时间">
                    </kc-date-picker>
                </kc-form-item>
                <kc-form-item label="状态" class="item">
                    <kc-select v-model="params.loginStatus" placeholder="请选择">
                        <kc-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </kc-option>
                    </kc-select>

                </kc-form-item>
            </kc-form>
            <span class="search-span" @click="handleSearch()">
                <i slot="suffix" class="icon kedaIconfont KD-sousuo  keda-icon-heavy-style"></i>
            </span>
        </div>
        <div class="table-form">
            <kc-table
                    ref="multipleTable"
                    :data="recordList"
                    tooltip-effect="dark"
                    height="580">
                <kc-table-column
                        prop="name"
                        label="状态"
                        width="60px">
                    <template slot-scope="scope">
                                            <span prop="loginStatus" :class="scope.row.loginStatus == 1 ? 'online' : 'outline'"></span>
<!--                        <span>{{scope.row.loginStatus == 1 ? 'online' : 'outline'}}</span>-->
                    </template>
                </kc-table-column>
                <kc-table-column
                        prop="userName"
                        label="用户名">
                </kc-table-column>
                <kc-table-column
                        label="日期"
                        prop="loginDate">
                </kc-table-column>
                <kc-table-column
                        prop="loginTime"
                        label="时间">
                </kc-table-column>
                <kc-table-column
                        prop="ip"
                        label="IP">
                </kc-table-column>
                <kc-table-column
                        prop="loginResult"
                        label="结果">
                </kc-table-column>
            </kc-table>
            <div class="pagination-wrapper" v-if="recordList.length > 0">
                <kc-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.pageNo"
                        :page-sizes="pageSizes"
                        :page-size="params.pageSize"
                        layout="sizes, prev, pager, next"
                        :total="total">
                </kc-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import {getOprationLogApi, searchOprationLogApi, getStatusApi} from '../../service/person';

    export default {
        name: 'KiafPersonalLog',
        data() {
            return {
                personalLogLoading: false,
                pageSizes: [5, 10, 20, 30, 60, 100],
                params: {
                    pageNo: 1,
                    pageSize: 5,
                    loginStatus: '',
                    statTime: '',
                    endTime: ''
                },
                total: 1,
                statTime: '',
                endTime: '',
                recordList: [],
                statusList: []
            };
        },
        methods: {
            /* 分页 */
            // 页数改变
            handleSizeChange(pageSize) {
                this.params.pageNo = 1;
                this.getRecordList(this.params);
            },
            // 当前页码变化
            handleCurrentChange(pageNo) {
                this.params.pageNo = pageNo;
                this.getRecordList(this.params);
            },
            getRecordList() {
              // for(let i = 0; i < 50; i++){
              //   this.recordList.push({
              //     loginStatus: i % 2,
              //     userName: 'userName' + i,
              //     loginDate: 'loginDate' + i,
              //     loginTime: 'loginTime' + i,
              //     ip: 'ip' + i,
              //     loginResult: 'loginResult' + i
              //   });
              // }
                this.personalLogLoading = true;
                getOprationLogApi(this.params).then(result => {
                    this.personalLogLoading = false;
                    this.recordList = result.records;
                    this.total = result.total;
                }, err => {
                    this.$message.warning(err);
                    this.personalLogLoading = false;
                });
            },
            getStatusList() {
                this.statusList = [
                    {value: '', label: '全部'}
                ];
                getStatusApi().then(result => {
                    if (result) {
                        result.forEach(item => {
                            this.statusList.push({value: item['cd'], label: item['description']});
                        });
                    }
                });
            },
            handleSearch() {
                this.personalLogLoading = true;
                this.params.pageNo = 1;
                if (this.statTime) {
                    this.params.statTime = this.timestampToTime(this.statTime);
                } else {
                    this.params.statTime = '';
                }
                if (this.endTime) {
                    this.params.endTime = this.timestampToTime(this.endTime);
                } else {
                    this.params.endTime = '';
                }
                //开始时间和结束时间都填或者都不填
                let a = this.params.statTime;
                let b = this.params.endTime;
                let timeReg = ((!a || !b) === true) && ((!a && !b) === false);
                if (timeReg) {
                    this.$message.warning('开始时间和结束时间都填或者都不填!');
                    return false;
                }
                if (this.params.endTime < this.params.statTime) {
                    this.$message.error('开始时间不能大于结束时间');
                    return;
                }
                searchOprationLogApi(this.params).then(result => {
                    this.personalLogLoading = false;
                    if (result.records) {
                        this.recordList = result.records;
                    }
                }, err => {
                    this.$message.warning(err);
                    this.personalLogLoading = false;
                });
            },
            formatTime(m) {
                return m < 10 ? '0' + m : m;
            },
            timestampToTime(timestamp) {
                let time = new Date(timestamp);
                let y = time.getFullYear();
                let m = time.getMonth() + 1;
                let d = time.getDate();
                let h = time.getHours();
                let mm = time.getMinutes();
                let s = time.getSeconds();
                return y + '-' + this.formatTime(m) + '-' + this.formatTime(d) + ' ' + this.formatTime(h) + ':' + this.formatTime(mm) + ':' + this.formatTime(s);
            }
        },
        created() {
            this.getStatusList();
            this.getRecordList();
        }
    };
</script>
<style lang="scss">
    @import "index.scss";
</style>
